import { Cast, ChevronRight, Eye, Square } from "lucide-react";

export function RemoteControlShowcase() {
  return (
    <section className="px-6 py-20 bg-[#0B0F19] text-white relative overflow-hidden" data-testid="section-remote-control">
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#4F46E5]/20 blur-[100px]" />
      <div className="absolute -bottom-24 -right-16 w-80 h-80 rounded-full bg-[#FF5733]/15 blur-[100px]" />
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center relative z-10">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#818CF8] bg-white/5 border border-white/10 px-3 py-1.5 rounded-full mb-5">
            <Cast className="w-3.5 h-3.5" /> New: Mobile Remote
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mb-4">
            Run the whole show from your pocket.
          </h2>
          <p className="text-white/60 leading-relaxed mb-8 max-w-md">
            Sign in on your phone or tablet, tap Remote on any presentation, and you're in control —
            walk the room while a laptop or projector shows the big screen.
          </p>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <span className="mt-0.5 w-8 h-8 rounded-lg bg-[#4F46E5]/20 flex items-center justify-center shrink-0"><ChevronRight className="w-4 h-4 text-[#818CF8]" /></span>
              <span className="text-white/70 text-sm pt-1">Big thumb-friendly Previous / Next buttons — no fumbling for tiny targets</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-0.5 w-8 h-8 rounded-lg bg-emerald-500/15 flex items-center justify-center shrink-0"><Eye className="w-4 h-4 text-emerald-400" /></span>
              <span className="text-white/70 text-sm pt-1">Reveal the correct quiz answer with one tap, right when the room is ready</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-0.5 w-8 h-8 rounded-lg bg-red-500/15 flex items-center justify-center shrink-0"><Square className="w-4 h-4 text-red-400" /></span>
              <span className="text-white/70 text-sm pt-1">Start and end the session, and watch responses roll in live — all from your hand</span>
            </li>
          </ul>
        </div>

        <div className="order-1 lg:order-2 flex justify-center">
          <div className="relative w-[260px] sm:w-[290px]" data-testid="phone-frame-remote">
            <div className="rounded-[2.5rem] border-[6px] border-[#1c1f2b] bg-[#1c1f2b] shadow-2xl shadow-black/50 overflow-hidden relative">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-5 bg-[#1c1f2b] rounded-b-2xl z-20" />
              <img src="/screenshots/remote_control.png" alt="VybeMeter mobile remote control" className="w-full block" />
            </div>
            <div className="absolute -right-2 top-24 w-1 h-16 bg-[#2a2e3d] rounded-full" />
            <div className="absolute -left-2 top-20 w-1 h-10 bg-[#2a2e3d] rounded-full" />
          </div>
        </div>
      </div>
    </section>
  );
}
